export default {
  namespaced: true,
  state: {
    selectedDevice: null,
    isFirstConnect: true,
  },
  mutations: {
    updateData(state, data) {
      console.log("data", data);
      Object.assign(state, data);
    },
    resetData(state) {
      state.selectedDevice = null;
      state.isFirstConnect = true;
    },
  },
};
